export class Distributor {
    constructor(public distributor : string){

    }
}
